import { useCallback } from "react"

/**
 * Заглушка телеграмного хаптика: в бэкофисе мини-аппа нет, вибрировать нечем.
 * API сохранён один в один с мини-аппом, чтобы перенесённые экраны не правились.
 */
export function useHaptic() {
	/** Отклик на касание: нажатие кнопки, тап по карточке. */
	const triggerHaptic = useCallback((_type: "light" | "medium" | "heavy" = "light") => {}, [])

	/** Итог операции: удалось или нет. */
	const triggerNotification = useCallback((_type: "success" | "warning" | "error") => {}, [])

	/** Перебор вариантов: чипы, вкладки. */
	const triggerSelection = useCallback(() => {}, [])

	return { triggerHaptic, triggerNotification, triggerSelection }
}
